import { createContext } from "react"
import { Theme } from "../../modules/design/Theme"
import { defaultTheme } from "../../modules/design/defaultTheme"

export const ThemeContext = createContext<Theme>(defaultTheme)
